import React from 'react';
import './common.css';
import { Link } from 'react-router-dom';

const Exclu=()=>{
    return(
        <div className="exclusive  clearfix">
            <h2>حصريا</h2>
            <div className="clearfix"></div>
            <p>هذه الخدمة متوفرة بشكل حصرى فى المنطقة التى يوجد بها المركز</p>
        </div>
    );
}

class Card extends React.Component{

    render(){
        const {title,desc,img,exclusive,advantages}=this.props;
        return(
            <div className="card" title={title}>
                <Link to={'services/'+title}>
                    <img src={img} alt=""/>
                    <div className="card-text ">
                        <h1>{title}</h1>
                        <p  className="cairo-font">{desc}</p>
                    </div>
                    <div className="advantages  clearfix">
                        <h2>الميزات</h2>
                        <div className="clearfix"></div>
                        <p>{advantages}</p>
                    </div>
                    {exclusive?<Exclu/>:null}
                </Link>    
            </div>
        );
    }
}
export default Card;

export const MiniCard=({src,title ,desc})=>{
    const style= {
        background:`url(${src}) no-repeat center`,
        height:"250px"
    };
    return(
        <div className="mini-card" title={desc}>
            <Link to={'services/'+title}>
                <div className="background" style={style}>
                </div>
                <div className="title"><h1>{title}</h1></div>
            </Link>    
        </div>
    );
}

export class SingleCard extends React.Component{

    render(){
        const {title,desc,img,exclusive,advantages}=this.props;
        return(
            <div className="single-card" title={title}>
                    <img src={img} alt=""/>
                    <section>
                        <div className="card-text ">
                            <h1>{title}</h1>
                            <p  className="cairo-font">{desc}</p>
                        </div>
                        <div className="advantages  clearfix">
                            <h2>الميزات</h2>
                            <div className="clearfix"></div>
                            <p>{advantages}</p>
                        </div>
                        {exclusive?<Exclu/>:null}
                    </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Card.js